import type { IMunicipality } from '../../../models/municipality.model';

export default class MunicipalityApiModel {
  gid!: string;
  name!: string;
  shortName!: string;
  number!: number;

  public static mapToBusinessModel(apiModel: MunicipalityApiModel): IMunicipality {
    return {
      gid: apiModel.gid,
      name: apiModel.name,
      shortName: apiModel.shortName,
    };
  }
}
